import * as React from 'react';
import style from './index.less';
import cx from 'classnames';
import Toast from '../toast';
import * as commonRegex from '../../utils/common-regex';
import lockAsync from '@src/utils/lock-async';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export default class SmsCodeInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countDown: null,
      validate: this.props.validate
    };
    this.loading = false;
    this.onSmsButtonClick = this.onSmsButtonClick.bind(this);
  }
  @lockAsync()
  async onSmsButtonClick() {
    const { sendCode, phone } = this.props;
    const validate = this.validate(phone);
    await this.setState({ loading: true });
    if (validate) {
      const sendCodeStatus = await sendCode({ phone: phone.replace(/\D+/g, '') }).catch(err => {
        this.setState({ loading: false });
        console.error(err.msg);
      });
      await this.setState({ loading: false });
      if (sendCodeStatus && sendCodeStatus.$state === 0) {
        return;
      }
      if (sendCodeStatus) {
        await this.countDown(60);
      }
    }
    await this.setState({ loading: false });
  }

  validate(phone) {
    let isValid = false;
    if (!phone) {
      Toast.info('手机号码不能为空');
    } else if (!commonRegex.phoneNumber.test(phone)) {
      Toast.info('请输入正确的手机号码');
    } else {
      isValid = true;
    }

    return isValid;
  }

  async countDown(countDown) {
    const nextCountDown = countDown - 1;
    if (nextCountDown < 1) {
      this.setState({ countDown: null });
      return;
    }
    this.setState({ countDown: nextCountDown });
    await delay(1000);
    await this.countDown(nextCountDown);
  }

  renderButton() {
    let { buttonText = '获取验证码' } = this.props;
    const { loading, countDown } = this.state;
    const { children } = this.props;
    buttonText = countDown === null ? buttonText : `${countDown} 秒后重试`;
    if (loading) {
      return <div className={style.loading} />;
    }
    return (
      <div className={style.btn} onClick={this.onSmsButtonClick}>
        {children}
        <div className={cx(style.sendButton, countDown !== null && style.noCursor)}>{buttonText}</div>
      </div>
    );
  }

  render() {
    // noinspection JSUnusedLocalSymbols
    const { validateAndGetPhone, codeBtnClassName, btnDisableClassName, ...restProps } = this.props;
    const { countDown } = this.state;
    return (
      <div className={style.smsCodeInput}>
        <div
          className={cx(style.smsButton, codeBtnClassName, {
            [style.btnDisable]: !!countDown,
            [btnDisableClassName]: !!countDown
          })}
        >
          {this.renderButton()}
        </div>
      </div>
    );
  }
}
